import React from 'react';
import { Icon } from '@frontend/icons';
import { Text } from '../../text';
import { ActionPressedChip } from '../atoms';
import { flexCenter } from '../common-styles';

type IndentIncreaseActionProps = Omit<React.ComponentProps<typeof ActionPressedChip>, 'children'>;

export const IndentIncreaseAction = ({ compact = true, showBoxShadow = true, ...rest }: IndentIncreaseActionProps) => {
  return (
    <ActionPressedChip {...rest} compact={compact} showBoxShadow={showBoxShadow}>
      <Text as='strong' weight='bold' className={flexCenter}>
        <Icon name='indent-increase-small' />
      </Text>
    </ActionPressedChip>
  );
};
